// eslint-disable-next-line import/named
import { Box } from "@mui/material";
import MuiChip, { ChipProps as MuiChipProps } from "@mui/material/Chip";``

interface ChipProps extends MuiChipProps {
  componentName: string;
  value: string | string[] | Date;
}

export const Chip = ({
  componentName,
  value,
  variant = "outlined",
  ...props
}: ChipProps) => {
  const formatValue = (val: string | Date): string =>
    val instanceof Date ? val.toLocaleDateString() : val?.toString();

  const values = Array.isArray(value)
    ? value.map(formatValue)
    : [formatValue(value)];

  return (
    <Box
      data-testid={`${componentName}-chip-container`}
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1,
        width: "100%",
        overflowWrap: "anywhere",
      }}
    >
      {values.map((val, index) => (
        <MuiChip
          {...props}
          data-testid={`${componentName}-chip`}
          key={index}
          label={val}
          variant={variant}
          sx={{ mx: 0.5, ...props.sx }}
        />
      ))}
    </Box>
  );
};
